import { Subscription } from '../models/model/concretes/shared/subcription.model';
import { environment } from "src/environments/environment";
import { GroupStep } from "../models/model/concretes/components/group-step.model";
import { LayoutInfo } from "../models/model/concretes/components/layout-info.model";
import { Step } from "../models/model/concretes/components/step.model";
import { isPartner } from "./brand-utils";
import { OPTION_PATH } from '../constants/route.constants';

export function createAnimalHealthSubscription(hasAvenants: boolean): Subscription {
  return new Subscription([
    new GroupStep([
      new Step(
        new LayoutInfo(1, 'Connaissance animale et date de couverture', 'Informations', 'Informations'),
        'information',
        true,
        false,
        false
      ),
      new Step(
        new LayoutInfo(1, 'Connaissance animale et date de couverture', 'Type et race', 'Animal/Sexe/Race'),
        'type-breed',
        false,
        false,
        false
      ),
      new Step(
        new LayoutInfo(1, 'Connaissance animale et date de couverture', 'Identification', 'Identification'),
        'identification',
        false,
        false,
        true
      ),
      new Step(
        new LayoutInfo(1, 'Connaissance animale et date de couverture', 'Vaccins', 'Vaccins'),
        'vaccines',
        false,
        false,
        true
      ),
      new Step(
        new LayoutInfo(1, 'Connaissance animale et date de couverture', 'Antécédents médicaux', 'Antécédents/Maladie'),
        'medical-history',
        false,
        false,
        true
      ),
      new Step(
        new LayoutInfo(1, 'Connaissance animale et date de couverture', 'Niveau de couverture'),
        'cover-level',
        false,
        false,
        true
      ),
      new Step(
        new LayoutInfo(1, 'Connaissance animale et date de couverture', 'Vos Informations'),
        'subscriber',
        false,
        false,
        true
      ),
      new Step(
        new LayoutInfo(2, 'Offre et création du devis', 'Formules'),
        'offer-customize',
        false,
        false,
        true
      ),
      new Step(
        new LayoutInfo(2, 'Votre offre', 'Option'),
        OPTION_PATH,
        false,
        false,
        true
      ),
      new Step(
        new LayoutInfo(2, 'Offre et création du devis', 'Confirmation Devis'),
        'quote-confirmation',
        false,
        false,
        true
      ),
      new Step(
        new LayoutInfo(3, 'Mise en place du prélèvement et création du contrat', 'Prélèvement'),
        'direct-debit',
        false,
        false,
        true
      ),
      new Step(
        new LayoutInfo(3, 'Mise en place du prélèvement et création du contrat', isPartner(environment) ? 'Accompagnement du client' : 'Questions additionnelles'),
        'cross-selling-c',
        false,
        false,
        true
      ),
      new Step(
        new LayoutInfo(
          4,
          'Signature des documents',
          hasAvenants
            ? 'Mise en place de votre avenant'
            : 'Vos documents contractuels'
        ),
        'special-conditions',
        false,
        false,
        true
      ),
      new Step(
        new LayoutInfo(4, 'Signature des documents', 'Confirmation'),
        'confirmation',
        false,
        false,
        true
      ),
      new Step(
        new LayoutInfo(4, 'Signature des documents', 'Questions additionnelles'),
        'cross-selling-w',
        false,
        false,
        true
      ),
      new Step(
        new LayoutInfo(4, 'Signature des documents', 'Validation du contrat'),
        'contract-validation',
        false,
        false,
        true
      )
    ])
  ]);
}

export function getSaStepPaths(hasAvenants: boolean): ReadonlySet<string>{
  return new Set(createAnimalHealthSubscription(hasAvenants).groupSteps.flatMap(group => group.steps.map(step => step.url)));
}
